import { useEffect } from "react";

/** Injecte des données structurées FAQPage (schema.org) pour les rich snippets Google. */
export default function FaqJsonLd({ faq = [] }) {
  useEffect(() => {
    const clean = (faq || []).filter((f) => f && f.q && f.a);
    if (clean.length === 0) return;
    const ld = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: clean.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    };
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-faq-ld", "1");
    el.text = JSON.stringify(ld);
    document.head.appendChild(el);
    return () => { document.querySelectorAll('script[data-faq-ld]').forEach((n) => n.remove()); };
  }, [JSON.stringify(faq)]);
  return null;
}
